import { createContext, useContext, useRef, MutableRefObject } from 'react'

interface ShareContextType {
    selfShareRef: MutableRefObject<HTMLCanvasElement | null>
}

const ShareContext = createContext<ShareContextType | undefined>(undefined)

export const ShareProvider = ({ children }: { children: React.ReactNode }) => {
    const selfShareRef = useRef<HTMLCanvasElement | null>(null)

    return (
        <ShareContext.Provider value={{ selfShareRef }}>
            {children}
        </ShareContext.Provider>
    )
}

export const useShare = () => {
    const context = useContext(ShareContext)
    if (!context) {
        throw new Error('useShare must be used within a ShareProvider')
    }
    return context
} 